import React, { useEffect, useState } from "react";
import {
 getAllTickets,
 getTicketDetail,
 replyToTicket,
 updateTicketStatus,
} from "../services/adminSupportService";
import { BRAND_COLOR } from "../../common/constants";

const AdminSupport = () => {
 const [tickets, setTickets] = useState([]);
 const [selectedTicketId, setSelectedTicketId] = useState(null);
 const [selectedTicket, setSelectedTicket] = useState(null);
 const [loadingList, setLoadingList] = useState(false);
 const [loadingDetail, setLoadingDetail] = useState(false);
 const [replyMessage, setReplyMessage] = useState("");
 const [statusUpdating, setStatusUpdating] = useState(false);

 /* ================= LOAD ALL TICKETS ================= */
 useEffect(() => {
 loadTickets();
 }, []);

 const loadTickets = async () => {
 setLoadingList(true);
 try {
 const res = await getAllTickets();
 setTickets(res.data || []);
 } catch (err) {
 } finally {
 setLoadingList(false);
 }
 };

 /* ================= LOAD TICKET DETAIL ================= */
 useEffect(() => {
 if (!selectedTicketId) return;
 fetchTicketDetail(selectedTicketId);
 }, [selectedTicketId]);

 const fetchTicketDetail = async (ticketId) => {
 setLoadingDetail(true);
 try {
 
 const res = await getTicketDetail(ticketId);
 setSelectedTicket(res.data);
 } catch (err) {

 } finally {
 setLoadingDetail(false);
 }
 };

 /* ================= SELECT TICKET ================= */
 const handleSelectTicket = (ticketId) => {
 if (!ticketId) return;
 setSelectedTicketId(ticketId);
 };

 /* ================= REPLY ================= */
 const handleReply = async () => {
 if (!replyMessage.trim() || !selectedTicketId) return;

 try {
 await replyToTicket(selectedTicketId, {
 message: replyMessage,
 });

 setReplyMessage("");
 fetchTicketDetail(selectedTicketId);
 } catch (err) {

 }
 };

 /* ================= UPDATE STATUS ================= */
 const handleUpdateStatus = async (status) => {
 if (!selectedTicketId) return;

 setStatusUpdating(true);
 try {
 await updateTicketStatus(selectedTicketId, status);
 fetchTicketDetail(selectedTicketId);
 loadTickets(); // refresh list status
 } catch (err) {

 } finally {
 setStatusUpdating(false);
 }
 };

 return (
 <div style={{ display: "flex", padding: 20, gap: 20 }}>
 {/* ================= TICKET LIST ================= */}
 <div style={{ width: "30%", borderRight: "1px solid #ddd", paddingRight: 20 }}>
 <h2 style={{ color: BRAND_COLOR }}>Support Tickets</h2>

 {loadingList ? (
 <p>Loading tickets...</p>
 ) : tickets.length === 0 ? (
 <p>No tickets found</p>
 ) : (
 tickets.map((ticket) => (
 <div
 key={ticket.id}
 onClick={() => handleSelectTicket(ticket.id)}
 style={{
 border:
 selectedTicketId === ticket.id
 ? `2px solid ${BRAND_COLOR}`
 : "1px solid #ccc",
 padding: 12,
 borderRadius: 6,
 marginBottom: 10,
 cursor: "pointer",
 }}
 >
 <p style={{ fontWeight: 600 }}>{ticket.name}</p>
 <p style={{ fontSize: 12, color: "#555" }}>{ticket.email}</p>
 <p style={{ fontSize: 12 }}>
 Status: <b>{ticket.status}</b>
 </p>
 <p style={{ fontSize: 11, color: "#777" }}>
 {new Date(ticket.createdAt).toLocaleString()}
 </p>
 </div>
 ))
 )}
 </div>

 {/* ================= TICKET DETAIL ================= */}
 <div style={{ width: "70%", paddingLeft: 20 }}>
 {!selectedTicket ? (
 <p>Select a ticket to view conversation</p>
 ) : loadingDetail ? (
 <p>Loading ticket...</p>
 ) : (
 <>
 <h2 style={{ color: BRAND_COLOR }}>
 Ticket #{selectedTicket.id}
 </h2>

 <p style={{ fontSize: 13, color: "#666" }}>
 {selectedTicket.userName} • {selectedTicket.email}
 </p>

 <p style={{ fontSize: 13 }}>
 Status: <b>{selectedTicket.status}</b>
 </p>

 {/* ================= STATUS CONTROLS ================= */}
 <div style={{ margin: "15px 0" }}>
 {["OPEN", "PENDING", "CLOSED"].map((status) => (
 <button
 key={status}
 onClick={() => handleUpdateStatus(status)}
 disabled={statusUpdating}
 style={{ marginRight: 10 }}
 >
 {status}
 </button>
 ))}
 </div>

 {/* ================= ROOT MESSAGE ================= */}
 <div
 style={{
 marginBottom: 16,
 padding: 12,
 borderRadius: 8,
 backgroundColor: "#f1f5f9",
 borderLeft: `4px solid ${BRAND_COLOR}`,
 }}
 >
 <p style={{ fontWeight: 600, margin: 0 }}>
 {selectedTicket.userName} (Ticket Created)
 </p>
 <p style={{ margin: "6px 0" }}>
 {selectedTicket.message}
 </p>
 <small style={{ color: "#666" }}>
 {new Date(selectedTicket.createdAt).toLocaleString()}
 </small>
 </div>

 {/* ================= CONVERSATION ================= */}
 <div
 style={{
 maxHeight: 400,
 overflowY: "auto",
 border: "1px solid #eee",
 padding: 12,
 }}
 >
 {selectedTicket.replies?.length > 0 ? (
 selectedTicket.replies.map((reply, index) => (
 <div
 key={`${reply.createdAt}-${index}`}
 style={{
 marginBottom: 12,
 padding: 8,
 borderRadius: 6,
 backgroundColor:
 reply.senderType === "ADMIN"
 ? "#eef3ff"
 : "#f7f7f7",
 textAlign:
 reply.senderType === "ADMIN" ? "right" : "left",
 }}
 >
 <p style={{ margin: 0 }}>{reply.message}</p>
 <small style={{ fontSize: 10, color: "#666" }}>
 {reply.senderType} •{" "}
 {new Date(reply.createdAt).toLocaleString()}
 </small>
 </div>
 ))
 ) : (
 <p style={{ color: "#777" }}>No replies yet</p>
 )}
 </div>

 {/* ================= REPLY BOX ================= */}
 <div style={{ marginTop: 15 }}>
 <textarea
 value={replyMessage}
 onChange={(e) => setReplyMessage(e.target.value)}
 rows={3}
 style={{
 width: "100%",
 padding: 10,
 borderRadius: 6,
 border: "1px solid #ccc",
 }}
 placeholder="Write your reply..."
 />

 <button
 onClick={handleReply}
 disabled={!replyMessage.trim()}
 style={{
 marginTop: 8,
 padding: "10px 15px",
 backgroundColor: BRAND_COLOR,
 color: "#fff",
 border: "none",
 borderRadius: 6,
 fontWeight: 600,
 }}
 >
 Send Reply
 </button>
 </div>
 </>
 )}
 </div>
 </div>
 );
};

export default AdminSupport;
